import { createCustomEventSystem } from '@frontend/event';

interface QuickFillCustomEvents {
  'quick-fill:person-added': { personId: string };
}
const { triggerCustomEvent: triggerQuickFillCustomEvent, useCustomEventListener: useQuickFillCustomEventListener } =
  createCustomEventSystem<QuickFillCustomEvents>();

export { triggerQuickFillCustomEvent, useQuickFillCustomEventListener };
